module.exports = __webpack_public_path__ + "static/4-4667d97e4fe0a5dade424b6e09526237.jpg";